export default __webpack_public_path__ + "d480192a2973c9e491dae979edf4049b.svg";